<template>
  <div>
    <b-loading :is-full-page="true" :active="loading" />
    <div class="w-full">
      <div class="flex items-center mb-4">
        <Icon-Info class="text-primary-600" size="8" />
        <p class="pl-4 font-display text-xl font-bold">
          Informações do Cliente
        </p>
      </div>
      <div
        v-if="getCliente.plans[0]"
        class="py-3 flex text-white"
        style="background-color: #1574a7"
      >
        <div class="flex items-center">
          <span class="pr-2 font-bold pl-1">Plano:</span>
        </div>
        <span v-text="getCliente.plans[0].name" />
      </div>
      <div class="py-3 flex">
        <div class="flex items-center">
          <span class="pr-2 font-bold">CPF:</span>
        </div>
        <span v-text="getCliente.cpf" />

        <b-icon
          @click.native="copyText(getCliente.cpf)"
          icon="content-copy"
          size="is-small"
          class="ml-1 mt-1"
          style="cursor: pointer"
        ></b-icon>
      </div>

      <div class="py-3 flex">
        <div class="flex items-center">
          <span class="pr-2 font-bold">Data de nascimento:</span>
        </div>
        <span v-text="data_nascimento" />

        <b-icon
          @click.native="copyText(data_nascimento)"
          icon="content-copy"
          size="is-small"
          class="ml-1 mt-1"
          style="cursor: pointer"
        ></b-icon>
      </div>
      <div class="py-3 flex">
        <div class="flex items-center">
          <span class="pr-2 font-bold">Idade:</span>
        </div>
        <span v-text="getCliente.idade" />
        <b-icon
          @click.native="copyText(getCliente.idade)"
          icon="content-copy"
          size="is-small"
          class="ml-1 mt-1"
          style="cursor: pointer"
        ></b-icon>
      </div>
      <form class="flex flex-col" @submit.prevent="onSubmit">
        <div class="flex items-center py-3">
          <div class="flex items-center">
            <span class="pr-2 font-bold">RG:</span>
          </div>
          <transition name="fade" mode="out-in">
            <span v-text="getCliente.rg" v-if="!isEditting && getCliente.rg" />
            <span v-else-if="!isEditting"> - </span>
            <Lynx-Input
              v-if="isEditting"
              v-model="$v.form.rg.$model"
              :error="$v.form.rg.$error"
            />
          </transition>

          <b-icon
            v-if="getCliente.rg"
            @click.native="copyText(getCliente.rg)"
            icon="content-copy"
            size="is-small"
            class="ml-1 mt-1"
            style="cursor: pointer"
          ></b-icon>
        </div>
        <div class="flex items-center py-3">
          <div class="flex items-center">
            <span class="pr-2 font-bold">PIS:</span>
          </div>
          <transition name="fade" mode="out-in">
            <span
              v-text="getCliente.pis"
              v-if="!isEditting && getCliente.pis"
            />
            <span v-else-if="!isEditting"> - </span>
            <Lynx-Input
              v-if="isEditting"
              v-model="$v.form.pis.$model"
              :error="$v.form.pis.$error"
            />
          </transition>

          <b-icon
            v-if="getCliente.pis"
            @click.native="copyText(getCliente.pis)"
            icon="content-copy"
            size="is-small"
            class="ml-1 mt-1"
            style="cursor: pointer"
          ></b-icon>
        </div>
        <div class="flex items-center py-3">
          <div class="flex items-center">
            <span class="pr-2 font-bold">Nacionalidade:</span>
          </div>
          <transition name="fade" mode="out-in">
            <span
              v-text="getCliente.nacionalidade"
              v-if="!isEditting && getCliente.nacionalidade"
            />
            <span v-else-if="!isEditting"> - </span>
            <b-select v-if="isEditting" v-model="form.nacionalidade">
              <option value="Brasileiro">Brasileiro</option>
            </b-select>
          </transition>
          <b-icon
            v-if="getCliente.nacionalidade"
            @click.native="copyText(getCliente.nacionalidade)"
            icon="content-copy"
            size="is-small"
            class="ml-1 mt-1"
            style="cursor: pointer"
          ></b-icon>
        </div>
        <div class="flex items-center py-3">
          <div class="flex items-center">
            <span class="pr-2 font-bold">Naturalidade:</span>
          </div>

          <transition name="fade" mode="out-in">
            <span
              v-text="getCliente.naturalidade"
              v-if="!isEditting && getCliente.naturalidade"
            />
            <span v-else-if="!isEditting"> - </span>
            <Lynx-Input
              v-if="isEditting"
              v-model="$v.form.naturalidade.$model"
              :error="$v.form.naturalidade.$error"
            />
          </transition>
        </div>
        <div class="items-center py-3">
          <div class="flex justify-between">
            <span class="font-bold">Faculdade:</span>
            <span
              style="font-size: 14px"
              class="mt-1"
              v-text="getCliente.course[0].ies.faculdade"
              v-if="!isEditting && getCliente.course[0]"
            />
            <span v-else-if="!isEditting"> - </span>
          </div>

          <transition name="fade" mode="out-in">
            <div>
              <Treeselect
                v-if="isEditting"
                style="width: 100%"
                placeholder="Escolha a Instituição de Ensino"
                v-model="$v.form.ies_id.$model"
                :options="
                  lista_ies.map((item) => ({
                    id: item.id,
                    label: item.faculdade,
                  }))
                "
              />
            </div>
          </transition>
        </div>
        <div class="flex items-center py-3">
          <div class="flex items-center">
            <span class="pr-2 font-bold">Turma:</span>
          </div>

          <transition name="fade" mode="out-in">
            <span
              v-text="getCliente.course[0].turma"
              v-if="!isEditting && getCliente.course[0]"
            />
            <span v-else-if="!isEditting"> - </span>
            <Lynx-Input v-if="isEditting" v-model="form.turma" type="number" />
          </transition>
        </div>
        <div
          class="flex items-center py-5"
          style="color: white"
          v-if="!isEditting"
        >
          <Lynx-Button
            text="Editar"
            icon="Edit"
            size="small"
            icon-size="4"
            @click.native="onEdit"
            type="button"
          />
          <Lynx-Button
            class=""
            text="Docs"
            icon="Document"
            size="small"
            icon-size="4"
            @click.native="openArquivosModal"
            type="button"
          />
          <Lynx-Button
            class=""
            text="Receitas"
            icon="Money"
            size="small"
            icon-size="4"
            type="button"
            @click.native="receitaModalOpened = true"
          />
        </div>
        <div class="flex items-center" style="color: white" v-if="!isEditting">
          <Lynx-Button
            class=""
            text="Reset Senha"
            icon="Setting"
            size="small"
            icon-size="4"
            type="button"
            @click.native="resetSenha"
          />
        </div>
        <div class="flex justify-between self-start py-4 w-full" v-else>
          <Lynx-Button
            text="Cancelar"
            :outlined="true"
            type="button"
            @click.native="cancelEditting"
            size="small"
          />
          <Lynx-Button text="Salvar" type="submit" size="small" />
        </div>
      </form>
    </div>

    <b-modal :active.sync="arquivosModalOpened">
      <Arquivos model-type="cliente" :model-id="getCliente.id" />
    </b-modal>

    <b-modal :active.sync="receitaModalOpened">
      <Receitas :customer-id="getCliente.id" />
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import Arquivos from "./Arquivos";
import { clientesUpdateRequest } from "@/services/requests/clientes";
import { mapGetters, mapActions } from "vuex";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import Receitas from "@/views/clientes/show/Receitas";
import formMixin from "@/mixins/form";
import Treeselect from "@riophae/vue-treeselect";
import { iesRequest } from "@/services/requests/clientePerfil";
export default {
  name: "ClienteShowInfos",
  components: { Receitas, Arquivos, Treeselect },
  mixins: [formMixin],
  data() {
    return {
      loading: false,
      arquivosModalOpened: false,
      receitaModalOpened: false,
      isEditting: false,
      form: {
        rg: "",
        pis: "",
        nacionalidade: "",
        naturalidade: "",
        ies_id: null,
        turma: null,
      },
      validationsMessage: {
        form: {
          rg: {
            required: "Inisra um RG",
            maxLength: "Insira um RG válido",
            minLength: "Insira um RG válido",
          },
          pis: { required: "Insira um PIS" },
          nacionalidade: { required: "Insira uma nacionalidade" },
          naturalidade: { required: "Insira uma naturalidade" },
          ies_id: { required: "Insira uma Instituição de Ensino" },
        },
      },
      ies: [],
    };
  },
  validations() {
    return {
      form: {
        rg: {
          required,
          maxLength: maxLength(9),
          minLength: minLength(9),
        },
        pis: { required },
        nacionalidade: { required },
        naturalidade: { required },
        ies_id: { required },
      },
    };
  },

  computed: {
    ...mapGetters(["getCliente"]),
    data_nascimento() {
      return moment(this.getCliente.data_nascimento).format("DD/MM/YYYY");
    },
    mensagem_alert() {
      return this.$store.state.empresas.mensagem_alert;
    },
    lista_ies() {
      return this.ies;
    },
  },
  methods: {
    ...mapActions(["setCliente"]),
    copyText(value) {
      this.$copyText(value);
    },
    clearForm() {
      this.form = {
        rg: "",
        pis: "",
        nacionalidade: "",
        naturalidade: "",
      };
    },
    async resetSenha() {
      await this.$store.dispatch("empresas/resetSenha", {
        cliente_id: this.getCliente.id,
      });
      this.$snack.success(this.mensagem_alert.message);
    },
    async onEdit() {
      this.loading = true;
      await this.getIes();
      this.loading = false;

      const course =
        this.getCliente.course && this.getCliente.course.length > 0
          ? this.getCliente.course[0]
          : {};

      this.form = {
        rg: this.getCliente.rg,
        pis: this.getCliente.pis,
        nacionalidade: this.getCliente.nacionalidade,
        naturalidade: this.getCliente.naturalidade,
        ies_id: course.ies_id || null,
        turma: course.turma || null,
      };
      this.isEditting = true;
    },
    cancelEditting() {
      this.clearForm();
      this.isEditting = false;
    },
    async onSubmit() {
      this.loading = true
     await clientesUpdateRequest(this.getCliente.id, this.form)
        .then((res) => {
          this.setCliente(res.data.data);
          this.clearForm();
          this.$snack.success("Informações atualizadas com sucesso");
          this.isEditting = false;
        })
        .catch(() =>
          this.$snack.error("Não foi possivel aterar as informações")
        );
        this.loading = false
    },
    openArquivosModal() {
      this.arquivosModalOpened = true;
    },
    async getIes() {
      await iesRequest().then((res) => (this.ies = res.data));
    },
  },
};
</script>
